import Icon from 'components/Icon'
import {
  getLogo,
  getPresetKeyFromURL
} from 'components/scenarios/create/status-checks/third-party-presets'
import { IntelligentHealthCheckVendorIcon } from 'components/status-checks/common/metrics/IntelligentHealthCheckVendorIcon'
import { muiTheme } from 'mui-theme'
import { type IntelligentHealthCheckType } from 'queries/intelligent-health-checks/types'
import theme from 'theme'
import {
  type ContinuousStatusCheckNode,
  type SynchronousStatusCheckNode
} from 'types/api/scenarios/scenario'

const ICON_SIZE = muiTheme.spacing(4)

/**
 * Shared size styles used by status check node icons inside `GlyphIcon`.
 */
export const STATUS_CHECK_NODE_ICON_STYLES = {
  height: ICON_SIZE,
  width: ICON_SIZE
}

type StatusCheckNodeIconProps = {
  ihcType?: IntelligentHealthCheckType
  isCustom?: boolean
  node: SynchronousStatusCheckNode | ContinuousStatusCheckNode
}

/**
 * Renders the correct visual icon for a Status Check graph node.
 */
export function StatusCheckNodeIcon({
  ihcType,
  isCustom,
  node
}: StatusCheckNodeIconProps) {
  if (ihcType) {
    return (
      <span aria-label="Vendor status check icon" role="img">
        <IntelligentHealthCheckVendorIcon
          type={ihcType}
          width={parseInt(ICON_SIZE)}
        />
      </span>
    )
  }

  if (isCustom) {
    return (
      <Icon
        aria-label="Custom status check icon"
        css={{ ...STATUS_CHECK_NODE_ICON_STYLES, color: theme.colors.gray[1] }}
        icon="wavePulse"
      />
    )
  }

  const logo = getLogo(getPresetKeyFromURL(node?.endpointConfiguration?.url))

  if (!logo) {
    return null
  }

  return <img alt="" css={STATUS_CHECK_NODE_ICON_STYLES} src={logo} />
}
